import { Card, CardBody, Col, Form, FormGroup, Input, Label, Row } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { FlatInputStyles, PleaseDoComments, SelectYourFavoriteRomanNumber, SelectYourMultiplePaintings } from "../../../../Constant";
import CommonSelectInput from "../Common/CommonSelectInput";
import { FLAT_INPUT_STYLES, FLAT_INPUT_STYLES_LIST, FLAT_STYLES_LIST } from "../../../../Data/FormControl/BaseInput";

const FlatInputStyle = () => {
  return (
    <Col md="6">
      <Card>
        <CommonCardHeader title={FlatInputStyles} span={FLAT_INPUT_STYLES} />
        <Form className="theme-form dark-inputs">
          <CardBody>
            <CommonSelectInput label={SelectYourFavoriteRomanNumber} inputClass="btn-square" span={FLAT_INPUT_STYLES_LIST} />
            <CommonSelectInput label={SelectYourMultiplePaintings} inputClass="btn-square" span={FLAT_STYLES_LIST} multiple />
            <Row>
              <Col>
                <FormGroup>
                  <Label check>{PleaseDoComments}</Label>
                  <Input type="textarea" className="btn-square" rows={3}></Input>
                </FormGroup>
              </Col>
            </Row>
          </CardBody>
        </Form>
      </Card>
    </Col>
  );
};

export default FlatInputStyle;
